import { render, staticRenderFns } from "./PermissionTargetChip.vue?vue&type=template&id=dd498b38&"
import script from "./PermissionTargetChip.vue?vue&type=script&lang=ts&"
export * from "./PermissionTargetChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports